import { render, staticRenderFns } from "./TheHeaderMobile.vue?vue&type=template&id=57435fcb&scoped=true&"
import script from "./TheHeaderMobile.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TheHeaderMobile.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TheHeaderMobile.vue?vue&type=style&index=0&id=57435fcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57435fcb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57435fcb')) {
      api.createRecord('57435fcb', component.options)
    } else {
      api.reload('57435fcb', component.options)
    }
    module.hot.accept("./TheHeaderMobile.vue?vue&type=template&id=57435fcb&scoped=true&", function () {
      api.rerender('57435fcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreHeader/components/mobile/TheHeader/TheHeaderMobile.vue"
export default component.exports